import { lazy } from 'react';

const CoordinatorProposalsList = lazy(() => import('./CoordinatorProposalsList'));

const ProposalsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'proposals',
      element: <CoordinatorProposalsList />,
    },
  ],
};

export default ProposalsConfig;
